export default "__VITE_ASSET__CMh1Orph__"